// Legal identity and contact details shown in the Privacy Policy, Terms, Shop terms,
// Copyright page and footer. Fill these in once; every page reads from here.
// Required by: India IT (Intermediary) Rules 2021 r.3(2) and DPDP Rules 2025 (Grievance
// Officer), Consumer Protection (E-Commerce) Rules 2020 (seller details), US DMCA §512(c)
// (designated agent). Empty fields are simply not rendered.
export const LEGAL = {
  operator: "Avika Ventures",
  site: "SaatSaheli (saatsaheli.com)",
  contactEmail: "avikaventures.info@gmail.com",
  // Registered / postal address of Avika Ventures (also used as the CAN-SPAM postal address).
  postalAddress: "",
  // GST registration number, if registered. Leave "" if not registered.
  gstin: "",

  // Shown as the "Complaints & Support contact" until a formal Grievance Officer is appointed.
  grievanceOfficer: {
    title: "Complaints & Support contact",
    name: "Chitra Sharma",
    email: "avikaventures.info@gmail.com",
    phone: "",
  },

  // US Copyright Office DMCA designated agent (register at dmca.copyright.gov, about $6).
  dmcaAgent: {
    registrationNumber: "",
    name: "",
    email: "avikaventures.info@gmail.com",
  },

  effectiveDate: "October 2026",
};
